/**
 * @author Akshay Kumar Singh
 * @file Auth Util
 * @flow
 */
import { getData } from "./storage.util";

/**
 * @description This is used to authenticate the user.
 */
const isAuthenticated = () => {
  if (!getData('isLogin') || !getData('token')) {
    return false;
  } else {
    return true;
  }
};

export {
  isAuthenticated,
}